"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CELL_SIZE_MAPPER = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
exports.CELL_SIZE_MAPPER = {
    regular: { height: 80, lineHeight: 5 },
    compact: { height: 64, lineHeight: 4 },
    dense: { height: 48, lineHeight: 3 },
    tight: { height: 32, lineHeight: 2 },
};
var Cell = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: (0, general_1.omitProps)('isSticky', 'hasBorderRight', 'hasGutter', 'offset', 'growCell', 'isActionCell', 'isFlexCenter', 'fontWeight', 'hasTitleColor'),
})(function (_a) {
    var hasBorderRight = _a.hasBorderRight, theme = _a.theme, isSticky = _a.isSticky, hasGutter = _a.hasGutter, offset = _a.offset, growCell = _a.growCell, isActionCell = _a.isActionCell, isFlexCenter = _a.isFlexCenter, left = _a.left, _b = _a.fontWeight, fontWeight = _b === void 0 ? 'regular' : _b, hasTitleColor = _a.hasTitleColor;
    return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ position: isSticky ? 'sticky' : 'relative', height: theme.spacing(10), lineHeight: theme.spacing(10), fontWeight: fontWeight === 'bold' ? 600 : 400, letterSpacing: theme.typography.body1.letterSpacing }, growCell && { flexGrow: 1 }), isFlexCenter && { flexDirection: 'column', justifyContent: 'center' }), hasBorderRight && { borderRight: "1px solid ".concat(theme.palette.grey[300]) }), (isSticky && left !== undefined) && { backgroundColor: theme.palette.common.white }), isSticky && { '&:hover': { zIndex: 1 } }), { '&:first-child': hasGutter && { paddingLeft: 0 }, '&:last-child': hasGutter && { paddingRight: 0 } }), isActionCell && {
        '&:nth-last-child(2)': { paddingRight: 0 },
    }), (hasGutter && !isActionCell) && __assign(__assign({ paddingRight: theme.spacing(1), paddingLeft: theme.spacing(1), '&:nth-last-child(2 of :not(#scrollRef))': { paddingRight: 0 } }, (offset === 'right' && { paddingRight: theme.spacing(hasBorderRight ? 4 : 2.5) })), (offset === 'left' && { paddingLeft: theme.spacing(2.5) }))), hasTitleColor && { color: theme.palette.text.secondary }), { '[class*="-option"]': {
            lineHeight: 1.5,
        }, '.showOnHover, &.showOnHover': {
            opacity: 0,
            transition: 'opacity 250ms ease 0s',
        }, '.displayOnHover, &.displayOnHover': {
            display: 'none',
        }, '.showOnHover:focus-within, &.showOnHover:focus-within': {
            opacity: 1,
            '.highlightInput': { borderColor: theme.palette.primary.light },
        }, '.compact-row &': __assign({}, exports.CELL_SIZE_MAPPER.compact), '.dense-row &': __assign({}, exports.CELL_SIZE_MAPPER.dense), '.tight-row &': __assign({}, exports.CELL_SIZE_MAPPER.tight) }));
});
exports.default = (0, DefaultPropsHoC_1.default)(Cell, {
    flex: 1,
});
